import React from "react"
import {connect} from "react-redux";
import BrowseView from "../../browse/BrowseView";
import {Row, Col} from "antd"
import {bindActionCreators} from "redux"
import * as LovTypeActions from "../../reducers/lov";
import PropTypes from "prop-types";
import LovResultDetailAffiliation from "./LovResultDetailAffiliation";
import LovResultDetailTable from "./LovResultLableTable";


class LovResultDetail extends React.Component {
    static propTypes = {
        lovLabel: PropTypes.array.isRequired,
        lovLabelFetch: PropTypes.bool.isRequired,
        lovs: PropTypes.array.isRequired,
        lovsSingle: PropTypes.bool.isRequired,
        getLovLabel: PropTypes.func.isRequired,
        search: PropTypes.func.isRequired
    };
    state = {
        selectedRowKeys: [],
        visible: false,
        confirmLoading: false
    };

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
        console.log("selectedRowKeys", selectedRowKeys);
        this.props.getLovs(selectedRowKeys);
    };

    // componentDidMount() {
    //     const {match, getLovLabel} = this.props;
    //     const urlId = match.params.id;
    //     getLovLabel(urlId);
    // }

    render() {
        const {lovLabel, lovLabelFetch, getLovLabel, lovs, lovsSingle, search, match: { params: { id: urlId }}} = this.props;
        console.log("LOV", lovLabel);
        console.log("lovLabelFetch", lovLabelFetch);
        const titleBar = <Row>
            <Col span={4}>LOV Labels</Col>
        </Row>;
        return <BrowseView
            masterTitle={titleBar}
            master={<LovResultDetailTable dataSource={lovLabel.lovResultResultList} onSelectChange={this.onSelectChange} loading={lovLabelFetch} compact={false}/>}
            initialQuery={() => getLovLabel(urlId)}
            vertical={true}
            detailTitle="LOV Results"
            detail={<LovResultDetailAffiliation links={lovs.lovResultDetailList} loading={lovsSingle}/>}
            searchableProps={["type"]}
            searchLogic={search}
            loading={lovLabelFetch} />;

    }

}

const mapStateToProps = state => ({
    lovLabelFetch: state.lov.lovLabelFetch,
    lovLabel: state.lov.lovLabel,
    lovs: state.lov.lovResult,
    lovsSingle: state.lov.lovTypesSingle
});

const mapDispatchToProps = dispatch => ({
    getLovLabel: bindActionCreators(LovTypeActions, dispatch).getLovLabel,
    getLovs: bindActionCreators(LovTypeActions, dispatch).getLovResult,
    search: bindActionCreators(LovTypeActions, dispatch).search
});

export default connect(mapStateToProps, mapDispatchToProps)(LovResultDetail)



// WEBPACK FOOTER //
// ./src/js/lovs/result/LovResultDetail.js